import React, { useEffect } from 'react';
import { FullscreenProps } from './types';
import { addClass, removeClass } from '@frontendUtils/helpers';

const Fullscreen = (props: FullscreenProps) => {
    const TransitionTime = 200;
    
    useEffect(() => {
        if (props.open) {
            setTimeout(() => {
                document.body.style['position'] = 'fixed'
                addClass(document.body, 'fullscreen-open')
                if (props.onShown) {
                    props.onShown()
                }
            }, TransitionTime)
        } else {
            document.body.style['position'] = 'relative'
            removeClass(document.body, 'fullscreen-open')
        }
    }, [props.open])

    useEffect(() => {
        return () => {
            document.body.style['position'] = 'relative'
            removeClass(document.body, 'fullscreen-open')
        }
    }, [])

    return (
        <div className={`full-screen ${props.open ? 'open' : ''}`}>
            <div className='full-screen__message' id="fullscreenServerMessageContainer"></div>
            <div className='full-screen__message' id="fullscreenInformationMessageContainer"></div>
            {props.children}
        </div>
    )
}

export default Fullscreen;
